module.exports = __webpack_public_path__ + "static/media/gif2.a393227a.gif";